import { handleDispatchResult } from "@utils/helpers/handleDispatchResult";

import { store } from "../store";
import {
  actions,
  getProfileAsync,
  getProfileStreakStatsAsync,
  getStreakDaysAsync,
  getTopConsumedCategoriesAsync,
  getUserAsync,
} from "./slices";
import { GetStreakDaysInput } from "./types";

export const clearReaderStatisticsState = () => {
  store.dispatch(actions.clear());
};

export const getProfile = async (onSuccess?: () => void | Promise<void>) => {
  const res = await store.dispatch(getProfileAsync());

  return handleDispatchResult(res, onSuccess);
};

export const getUser = async (onSuccess?: () => void | Promise<void>) => {
  const res = await store.dispatch(getUserAsync());

  return handleDispatchResult(res, onSuccess);
};

export const getTopConsumedCategories = async (
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(getTopConsumedCategoriesAsync());

  return handleDispatchResult(res, onSuccess);
};

export const getProfileStreakStats = async (
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(getProfileStreakStatsAsync());

  return handleDispatchResult(res, onSuccess);
};

export const getStreakDays = async (
  body: GetStreakDaysInput,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(getStreakDaysAsync(body));

  return handleDispatchResult(res, onSuccess);
};
